import { Link as e } from "./index3.js";
class s {
  homePage;
  aboutPage;
  contactPage;
  helpCenterPage;
  businessSolutionPage;
  legalDocumentsPage;
  resourcesPage;
  blogPage;
  affiliatePage;
  whiteLabelPage;
  careersPage;
  cancelPage;
  legalNoticePage;
  lawLibraryPage;
  termsPage;
  privacyPage;
  cookiePage;
  constructor() {
    this.homePage = new e(!0, "/"), this.aboutPage = new e(!0, "/about.php"), this.contactPage = new e(!1), this.helpCenterPage = new e(!0, "/help/"), this.businessSolutionPage = new e(!0, "/business-solutions/"), this.legalDocumentsPage = new e(!1), this.resourcesPage = new e(!0, "/resources/"), this.blogPage = new e(!0, "/blog/"), this.affiliatePage = new e(!0, "/affiliate/"), this.whiteLabelPage = new e(!0, "/white-label/"), this.careersPage = new e(!0, "/career/"), this.cancelPage = new e(!1), this.legalNoticePage = new e(!1), this.lawLibraryPage = new e(!1), this.termsPage = new e(!0), this.privacyPage = new e(!1), this.cookiePage = new e(!1);
  }
}
export {
  s as FooterLinks
};
//# sourceMappingURL=index2.js.map
